export function BrandAvatar({ className = "h-9 w-9", ring = "" }) {
  return (
    <img
      src={`${process.env.PUBLIC_URL}/ayush-avatar.jpg`}
      alt="Ayush"
      loading="lazy"
      className={`shrink-0 rounded-full object-cover ${ring} ${className}`}
      data-testid="brand-avatar"
    />
  );
}
